// Self-healing for returning devices after a deploy.
// 1) An OLD build may have registered a caching (Workbox/CRA) service worker that keeps
//    serving stale chunks -> app hangs/renders blank. We unregister any non-Firebase SW
//    and clear its caches, then reload once.
// 2) A missing chunk is served as index.html (HTTP 200 text/html) -> "Unexpected token '<'"
//    / ChunkLoadError. We reload once to fetch the fresh, no-cache index.html + chunks.
const ONCE = (key) => {
  try {
    if (sessionStorage.getItem(key)) return false;
    sessionStorage.setItem(key, "1");
    return true;
  } catch {
    return true;
  }
};

export function initSelfHeal() {
  // --- Stale service worker cleanup (keep only Firebase messaging SW) ---
  try {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.getRegistrations().then((regs) => {
        let killed = false;
        regs.forEach((reg) => {
          const url =
            (reg.active && reg.active.scriptURL) ||
            (reg.waiting && reg.waiting.scriptURL) ||
            (reg.installing && reg.installing.scriptURL) || "";
          if (url && url.indexOf("firebase-messaging-sw") === -1) {
            reg.unregister();
            killed = true;
          }
        });
        if (killed) {
          if (window.caches && caches.keys) {
            caches.keys().then((keys) => keys.forEach((k) => caches.delete(k))).catch(() => {});
          }
          if (ONCE("wyvn_sw_healed")) window.location.reload();
        }
      }).catch(() => {});
    }
  } catch {}

  // --- Recover from a failed chunk load (stale reference after deploy) ---
  const looksLikeChunkError = (msg) =>
    /Loading chunk [\d]+ failed|ChunkLoadError|Loading CSS chunk|Unexpected token '<'|expected expression, got '<'/i.test(msg || "");

  window.addEventListener("error", (e) => {
    if (looksLikeChunkError(e && e.message) && ONCE("wyvn_chunk_reload")) window.location.reload();
  });
  window.addEventListener("unhandledrejection", (e) => {
    const msg = (e && e.reason && (e.reason.message || String(e.reason))) || "";
    if (looksLikeChunkError(msg) && ONCE("wyvn_chunk_reload")) window.location.reload();
  });
}
